import { useState } from "react";
import { ReactDatePickerProps } from "react-datepicker";
import { BaseSelect } from "./BaseSelect";
import RangeDatepicker from "./RangeDatepicker";

interface Props extends Omit<ReactDatePickerProps<never, true>, "startDate" | "endDate"> {
  dateRange: [Date | null, Date | null];
  disabled?: boolean;
  stateOptions: Array<{
    value: string | number;
    label: string;
    isDisabled?: boolean;
  }>;
  selectWidth?: number;
  selectValue?: string | number | null;
  setStateValue: Function;
  onClearClick?: () => void;
}

function RangeDatepickerWithSelect(props: Props) {
  const [isFocus, setIsFocus] = useState(false);

  return (
    <div className={`range-datepicker-input with-search ${isFocus ? "range-datepicker-input__focus" : ""}`}>
      <div className={props.selectWidth ? `minmax${props.selectWidth}` : "minmax148"}>
        <BaseSelect
          onFocus={() => setIsFocus(true)}
          onBlur={() => {
            setIsFocus(false);
          }}
          value={props.selectValue}
          placeholder={"기간 옵션"}
          stateOptions={props.stateOptions}
          setStateValue={props.setStateValue}
        />
      </div>
      <RangeDatepicker dateRange={props.dateRange} onChange={props.onChange} onClearClick={props.onClearClick} />
    </div>
  );
}
export default RangeDatepickerWithSelect;
